import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
// import "./signIn.css";
import intl from "react-intl-universal";
import ReCAPTCHA from "react-google-recaptcha";
import LoaderButton from "./components/LoaderButton";
import DivsPattern from "./components/skylineDesignPattern";

class SignIn extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      password: "",
      rememberMe: false,
      isLoginFailed: false,
      isLoading: false,
      errorMessage: intl.get("General_Failure"),
      recaptchSucceeded: false,
      failureTimes: 0,
      afterActivation: false,
      isGettingStartedNavigation: false,
      passwordInputType: "password",
      socialesLogin: [],
      codeFromIdp: '',
      idpParams: '',
      showFullImageLoader: false
    };

    this._reCaptchaRef = React.createRef();
  }

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const codeFromIdp = urlParams.get('code');
    const idpParams = urlParams.get('state');
    if(codeFromIdp){
      this.props.handleUpdates({showHeader: false})
      this.setState({codeFromIdp, idpParams, showFullImageLoader: true}, () =>{
        this.getSocialesLogin();
        this.handleSubmit();
      })
      return;
    }

    var afterActivationFlag =
      window.location.search.match(/[?&]afterActivation[=]1/gi) !== null;
    if (afterActivationFlag) this.setState({ afterActivation: true });

    if (window.location.href.match(/gettingStarted/gi) !== null)
      this.setState({ isGettingStartedNavigation: true });

    this.getSocialesLogin();
  }

  getSocialesLogin = () => {
    fetch(
      process.env.REACT_APP_API_URL + "GetSocialesLogin",
      {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
    .then((res) => res.json())
    .then((res) => {
        this.setState({
          socialesLogin: res
        });
    });
  }

  handleRecaptchChange = (value) => {
    this.setState({ recaptchSucceeded: true });
  };

  asyncScriptOnLoad = () => {
    this.setState({ callback: "called!" });
  };

  validateForm() {
    if(this.state.codeFromIdp != ''){
      return true;
    }

    return (
      this.state.email.length > 0 &&
      this.state.password.length > 0 &&
      (this.state.failureTimes < 3 || this.state.recaptchSucceeded)
    );
  }

  handleSubmit = () => {
    if (!this.validateForm()) {
      this.setState({ errorMessage: intl.get("Mandatory_Fields_Error") });
      return;
    }
    this.setState({ isLoading: true });
    fetch(process.env.REACT_APP_API_URL + "login", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        Email: this.state.email,
        Password: this.state.password,
        Remember: this.state.rememberMe,
        CodeFromIdp: this.state.codeFromIdp,
        State: this.state.idpParams 
      }),
    })
      .then((res) => res.json())
      .then((result) => {
        this.props.handleUpdates({showHeader: true})
        this.setState({ showFullImageLoader: false, isLoading: false});
        if (
          result.Result &&
          result.Result.toString().toLowerCase() === "success"
        ) {
          this.setState({ isLoginFailed: false});
          this.props.userHasAuthenticated(
            true,
            result.FirstName,
            result.LastName,
            result.Username,
            result.CustomerId,
            (result.SubLoginType == "EndpointWebGUI") ? true : false
          );
        } else if (result.Result.toString().toLowerCase() === "notactive") {
          this.setState({ isLoginFailed: true, errorMessage: intl.get("User_InActivated")});
        } else if (result.Result.toString().toLowerCase() === "notfound") {
          this.setState({ isLoginFailed: true, errorMessage: intl.get("User_NotFound")});
        } else {
          this.setState({ isLoginFailed: true, failureTimes: this.state.failureTimes + 1, errorMessage: intl.get("Login_Failed") });
        }
      })
      .catch((error) => {
        this.props.handleUpdates({showHeader: true})
        this.setState({ showFullImageLoader: false, isLoading: false});
        console.error(error);
        this.props.handleServerError(true);
      });
  };

  handleLoginIconClick = (row) =>{
    const idpUrl = row.LoginUrl;
    var stateObj = {
      'cloudSSOKey': row.Name
    }
    var stateObjStr = JSON.stringify(stateObj);
    var stateObjB64 = btoa(stateObjStr);        // Convert to Base64

    const queryParams = new URLSearchParams({
      state: stateObjB64, // Pass the stateObj in Base64 as the State parameter
    });

    const fullUrl = `${idpUrl}&${queryParams.toString()}`;
    window.open(fullUrl, '_self');
  }

  render() {
    if (this.state.showFullImageLoader) {
      return (
        <div className="cssload-loader">
          <div className="cssload-square cssload-square--main">
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
          </div>
        </div>
      );
      // return <div className="loader" />;
    }
    return (
      <DivsPattern headerText={intl.get("Sign_In_Welcome")}>
        {this.state.afterActivation !== false ? (
          <div className="afterActivationSignIn">
            {intl.get("After_Activation_Sign_In")}
          </div>
        ) : null}
        <form id="formSignIn" className="form-signin" onSubmit={(event) =>{
            event.preventDefault();
            this.setState({codeFromIdp: ''}, ()=>{
              this.handleSubmit();
            });
          }}>
          <div id="emailDiv" className="form-label-group">
            <span id="reauth-email" className="reauth-email" />
            <input
              id="emailInputField"
              type="email"
              onChange={(event) => this.setState({ email: event.target.value })}
              className="form-control"
              placeholder={intl.get("Eamil_Address_Test")}
              value={this.state.email}
              autoFocus
              required
            />
          </div>
          <div id="passwordDiv" className="form-label-group">
            <input
              type="password"
              id="passwordIdField"
              onChange={(event) =>
                this.setState({ password: event.target.value })
              }
              className="form-control"
              placeholder={intl.get("Password_Test")}
              value={this.state.password}
              type={this.state.passwordInputType}
              required
            />
            <a
              onClick={(event) => {
                this.state.passwordInputType === "password"
                  ? this.setState({ passwordInputType: "text" })
                  : this.setState({ passwordInputType: "password" });
              }}
              id="aEyePasswordLinkId"
            >
              <i
                className={
                  this.state.passwordInputType === "password"
                    ? "fa fa-eye-slash fa-flip-horizontal"
                    : "fa fa-eye"
                }
                style={{
                  color: "gray",
                  right: "16px",
                  position: "absolute",
                  top: "17px",
                }}
                aria-hidden="true"
                id="iEyePassword"
              />
            </a>
          </div>
          <div id="rememberDiv" className="custom-control custom-checkbox mb-3">
            <input
              type="checkbox"
              id="rememberMeCheckbox"
              defaultChecked={this.state.rememberMe}
              onChange={(event) =>
                this.setState({
                  rememberMe: event.target.checked,
                })
              }
              className="custom-control-input"
              id="forgotPasswordId"
            />
            <label id="rememberMeCheckboxLabel" className="custom-control-label" htmlFor="forgotPasswordId">
              {intl.get("Remember_Me")}
            </label>
          </div>
          {this.state.failureTimes > 2 ? (
            <ReCAPTCHA
              id="captchaId"
              className="form-label-group"
              style={{ textAlign: "-webkit-center" }}
              ref={this._reCaptchaRef}
              sitekey={"6LeGzZsUAAAAALreua0d6EHa5KYeao1aaE1QCGup"}
              onChange={this.handleRecaptchChange}
              asyncScriptOnLoad={this.asyncScriptOnLoad}
            />
          ) : null}
          <LoaderButton
            id="logInButtonLoaderButton"
            className="btn-lg btn btn-primary btn-block btn-login text-uppercase font-weight-bold mb-2 btn-login"
            type="submit"
            isLoading={this.state.isLoading}
            text={intl.get("Sign_In")}
            loadingText={intl.get("Signing_In")}
          />
          {this.state.isLoginFailed ? (
            <div id="divError">
              <span style={{ color: "red" }}>{this.state.errorMessage}</span>
            </div>
          ) : null}
          <div id="forgotPasswordDiv" className="text-center">
            <Link id="forgotPasswordLink" className="small" to="/forgotPassword">
              {intl.get("Forgot_Password")}
            </Link>
          </div>
          {this.state.isGettingStartedNavigation ? (
            <div id="skipDiv" className="text-center">
              <Link id="skipLink" className="" to={ (window.location.search.match(/[?&]redirect=[^&]+/i) != null ? decodeURIComponent(window.location.search.match(/[?&]redirect=([^&]+)/i)[1]) : "/gettingStarted") + window.location.hash }>
                {intl.get("Skip")}
              </Link>
            </div>
          ) : null}
          <div className="icon-list">
            {this.state.socialesLogin.map((row, i)=>{
              return(
                  <img key={i} src={row.LoginIcon} onClick={() => {
                    this.handleLoginIconClick(row)
                  }}/>
              )
            })}
          </div>
        </form>
      </DivsPattern>
    );
  }
}

export default withRouter(SignIn);
